/**
 * Reference lists that customer orders and segment rules point at — MOCK.
 *
 * Outlets, menu items and categories are stand-ins until customer orders carry real ids;
 * going live these come from the branch and product catalogue data. Customers and Campaigns
 * both read them from here so the ids always agree.
 */
import type { Daypart, OrderChannel, RuleOption } from '../../components/customers/data/types';
import { ORDER_CHANNEL_LABELS } from '../../components/customers/data/types';

export const mockOutlets: RuleOption[] = [
  { id: 'out_princeton', name: 'Princeton' },
];

export const mockCategories: RuleOption[] = [
  { id: 'cat_dosa', name: 'Dosas' },
  { id: 'cat_curry', name: 'Curries' },
  { id: 'cat_biryani', name: 'Biryani' },
  { id: 'cat_drinks', name: 'Drinks' },
  { id: 'cat_dessert', name: 'Desserts' },
];

export const mockItems: (RuleOption & { categoryId: string })[] = [
  { id: 'item_masala_dosa', name: 'Masala Dosa', categoryId: 'cat_dosa' },
  { id: 'item_ghee_dosa', name: 'Ghee Roast Dosa', categoryId: 'cat_dosa' },
  { id: 'item_rava_dosa', name: 'Rava Dosa', categoryId: 'cat_dosa' },
  { id: 'item_paneer_butter', name: 'Paneer Butter Masala', categoryId: 'cat_curry' },
  { id: 'item_chettinad', name: 'Chicken Chettinad', categoryId: 'cat_curry' },
  { id: 'item_sambar', name: 'Sambar Bowl', categoryId: 'cat_curry' },
  { id: 'item_veg_biryani', name: 'Vegetable Biryani', categoryId: 'cat_biryani' },
  { id: 'item_chicken_biryani', name: 'Chicken Biryani', categoryId: 'cat_biryani' },
  { id: 'item_filter_coffee', name: 'Filter Coffee', categoryId: 'cat_drinks' },
  { id: 'item_mango_lassi', name: 'Mango Lassi', categoryId: 'cat_drinks' },
  { id: 'item_gulab_jamun', name: 'Gulab Jamun', categoryId: 'cat_dessert' },
  { id: 'item_payasam', name: 'Payasam', categoryId: 'cat_dessert' },
];

export const ORDER_CHANNEL_OPTIONS: { id: OrderChannel; name: string }[] =
  (Object.keys(ORDER_CHANNEL_LABELS) as OrderChannel[]).map((id) => ({ id, name: ORDER_CHANNEL_LABELS[id] }));

export const DAYPART_OPTIONS: { id: Daypart; name: string }[] = [
  { id: 'breakfast', name: 'Breakfast' },
  { id: 'lunch', name: 'Lunch' },
  { id: 'dinner', name: 'Dinner' },
  { id: 'late_night', name: 'Late night' },
];

/** Offered only when TIERS_ENABLED is on. */
export const mockTiers: RuleOption[] = [
  { id: 'tier_bronze', name: 'Bronze' },
  { id: 'tier_silver', name: 'Silver' },
  { id: 'tier_gold', name: 'Gold' },
];

/** Deterministic PRNG so mock data is the same on every reload. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
